export enum SaleTransactionHistoryTypeEnum {
    Created = 'created',
    StatusChanged = 'status_changed',
    PaymentInitiated = 'payment_initiated',
    PaymentCompleted = 'payment_completed',
    PaymentFailed = 'payment_failed',
    Cancelled = 'cancelled',
    Refunded = 'refunded',
    ProductEpcAdded = 'product_epc_added',
    ProductEpcRemoved = 'product_epc_removed',
    ProductAdded = 'product_added',
    ProductRemoved = 'product_removed',
    LineDiscountApplied = 'line_discount_applied',
    LineDiscountRemoved = 'line_discount_removed',
    EmployeeDiscountApplied = 'employee_discount_applied',
    EmployeeDiscountRemoved = 'employee_discount_removed',
}
